// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStataptsusde } from "../../../icons/mono/build/icon-stataptsusde.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StataptsusdeIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStataptsusde.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StataptsusdeIcon.displayName = 'StataptsusdeIcon';
}

export default StataptsusdeIcon;